import { Link } from '@mui/material';

import PageFactory from '../PageFactory';
import SystemErrorIllustration from './SystemErrorIllustration';

export const STATUS_PAGE_URL = 'https://status.vatix.com';

const SystemError = (): React.ReactNode =>
  PageFactory(SystemErrorIllustration, 'Something Went Wrong', [
    'The page is currently unavailable.',
    <>
      Check{' '}
      <Link href={STATUS_PAGE_URL} target="_blank" rel="noopener noreferrer">
        status.vatix.com
      </Link>{' '}
      to see if there is a known issue.
    </>,
    'Please try again later or contact support@vatix.com',
  ]);

export default SystemError;
